const props = {
  addProperties: {
    type: Object,
    default: () => {
      return {};
    },
    description: 'Propiedades para la sección de agregar un nuevo registro',
  },
  dataBadges: {
    type: Array,
    default: () => {
      return [];
    },
    description: 'Badges de los datos',
  },
  exportProperties: {
    description: 'Propiedades para la tabla',
  },
  routeMenu: {
    type: String,
    default: null,
    description:
      'Ruta de selección para el menú, lo que indica en que módulo esto posicionado',
  },
  route: {
    type: String,
    default: null,
    description: 'Ruta general del módulo',
  },
  showDrawer: {
    type: Boolean,
    default: false,
    description: 'Mostrar la información seleccionada como un drawer',
  },
  showProperties: {
    type: Object,
    default: () => {
      return {};
    },
    description: 'Propiedades para la visualización de los datos seleccionados',
  },
  tableProperties: {
    type: Object,
    default: () => {
      return {};
    },
    description: 'Propiedades para la tabla',
  },
  refreshDetail: {
    type: Object,
    default: () => {
      return {};
    },
    description: 'Detalle que se actualizara en la tabla',
  },
  showExportTables: {
    type: Boolean,
    default: true,
    description: 'Mostrar los botones de exportación',
  },
};

export default props;
